module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-nginx-02-m-en.44f1d2af71dca675b514ae1c9b8afd51.png";